<script>
    import {viewMode} from './stores/LocalStorage.js';
    import Modal from './Modal.svelte';
    import loggedInUser from './stores/LoggedInUser.js';
    let show = false;
    
    $: {
        // Prevent login from flickering on screen while requesting ./auth
        setTimeout(() => { 
            if(!$loggedInUser.user_id) {show = true } else {show = false};
        }, 1000);
    }
    
</script>

<Modal {show} allowClose={false}>
    <span slot="title">Please log in</span>
    <div slot="content">
        <p>
            <a href="/.auth/login/aad?post_login_redirect_uri=/">Log in with Microsoft</a>
        </p>
        <p>
            <!-- svelte-ignore a11y-missing-attribute -->
            <a on:click={ () => viewMode.update({tag: 'home'})} on:keydown={() => {}}>Not now</a>
        </p>
    </div>
</Modal>